import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import useApi from '../../hooks/ApiHook';
import useToast from '../../hooks/ToastHook';
import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';

const header = (
    <div>
        <h2>Envie a nota fiscal</h2>
    </div>
)

export default function NewMovementSidebar({ visible, onHide, onSuccess }) {

    const [ missingData, setMissingData ] = useState();
    const [ file, setFile ] = useState();

    const hide = () => {
        setMissingData(null);
        setFile(null);
        onHide();
    }

    const success = () => {
        onSuccess();
        hide();
    }

    return (
        <Sidebar visible={visible} onHide={hide} position='right' className="md:w-30rem" header={header}>
            {missingData ? (
                <MissingDataInput 
                    file={file} 
                    model={missingData} 
                    onSuccess={success} 
                    onCancel={hide}/>
            ) : (
                <NfeInput 
                    file={file} 
                    onUpload={setFile} 
                    onRequestMissingData={setMissingData} 
                    onSuccess={success} onCancell={hide}/>
            )}
        </Sidebar>
    )
}

const NfeInput = ({ file, onUpload, onRequestMissingData, onSuccess, onCancell }) => {

    const api = useApi();
    const { showAxiosError, showSuccess } = useToast();
    const [ loadingNfe, setLoadingNfe ] = useState(false);

    const openFilePicker = () => {
        document.getElementById('file-input').click();
    }

    const pickFile = async e => {
        console.log(e.target.files[0]);
        onUpload(e.target.files[0]);
    }

    const uploadNfe = async () => {
        setLoadingNfe(true);
        var formData = new FormData();
        formData.append("file", file);
        try {
            await api.post('movements/shipment/xml', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
            showSuccess('Importado com sucesso');
            onSuccess();
        } catch (e) {
            if (e.response.status === 422) {
                onRequestMissingData(e.response.data);
                return;
            }
            console.log(e);
            showAxiosError(e);
        } finally {
            setLoadingNfe(false);
        }
    }

    const hide = () => {
        onUpload(null);
        onCancell();
    }

    return (
        <>
            <label>Insira o arquivo da nota fiscal</label>
            <InputText
                readOnly
                value={file?.name || ''}
                className="w-full mt-3 cursor-pointer"
                placeholder="Clique para selecionar um arquivo"
                onClick={openFilePicker}/>
            <input id="file-input" type="file" name="name" className="hidden" onChange={pickFile} accept="text/xml"/>
            <div className="flex pt-3 gap-2">
                <Button label="Importar" disabled={!file} onClick={uploadNfe} loading={loadingNfe}/>
                <Button label="Cancelar" outlined onClick={hide}></Button>
            </div>
        </>
    )

}

const MissingDataInput = ({ model, file, onSuccess, onCancel }) => {

    const api = useApi();
    const { showAxiosError, showSuccess } = useToast();
    const [ inputData, setInputData ] = useState([]);
    const [ loadingNfe, setLoadingNfe ] = useState(false);

    useEffect(() => {
        setInputData(model.map((m, i) => ({
            index: i,
            code: m.code,
            description: m.description,
            ratioValue: m.defaultUnit ? 0 : null,
            grossWeight: m.requiringWeight ? 0 : null,
            netWeight: m.requiringWeight ? 0 : null,
            defaultUnit: m.defaultUnit,
            informedUnit: m.informedUnit,
            requiringWeight: m.requiringWeight
        })));
    }, [model]);

    const uploadNfe = async () => {
        setLoadingNfe(true);
        var formData = new FormData();
        formData.append("file", file);
        formData.append("info", JSON.stringify(inputData));
        try {
            await api.post('movements/shipment/xml', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
            showSuccess('Importado com sucesso');
            onSuccess();
        } catch (e) {
            console.log(e);
            showAxiosError(e);
        } finally {
            setLoadingNfe(false);
        }
    }

    const setValue = (index, property, value) => {
        inputData[index][property] = value;
        setInputData([...inputData]);
    }

    return (
        <>
            {inputData.map(m => (
                <div className='mb-3'>
                    <div className='font-semibold'>{m.description}</div>
                    <div class="formgrid grid mt-3">
                        {m.defaultUnit && (
                            <div class="field col-12">
                                <label>Unidade de medida</label>
                                <div className="p-inputgroup flex-1">
                                    <span className="p-inputgroup-addon">
                                        1 {m.informedUnit} = 
                                    </span>
                                    <InputNumber
                                        value={0}
                                        maxFractionDigits={4}
                                        suffix={' ' + m.defaultUnit}
                                        onChange={e => setValue(m.index, 'ratioValue', e.value)}
                                        locale="pt-BR"/>
                                </div>
                            </div>
                        )}
                        {m.requiringWeight && (
                            <>
                                <div class="field col-6">
                                    <label>Peso bruto ({m.informedUnit})</label>
                                    <InputNumber
                                        value={0} 
                                        maxFractionDigits={4}
                                        suffix={' g'}
                                        locale="pt-BR"
                                        inputStyle={{ minWidth: 10 }}
                                        onChange={e => setValue(m.index, 'grossWeight', e.value)}
                                        className='w-full'/>
                                </div>
                                <div class="field col-6">
                                    <label>Peso líquido</label>
                                    <InputNumber
                                        value={0} 
                                        maxFractionDigits={4}
                                        suffix={' g'}
                                        locale="pt-BR"
                                        inputStyle={{ minWidth: 10 }}
                                        onChange={e => setValue(m.index, 'netWeight', e.value)}
                                        className='w-full'/>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            ))}
            <div className="flex gap-2">
                <Button label="Importar" onClick={uploadNfe} loading={loadingNfe}/>
                <Button label="Cancelar" outlined onClick={onCancel} disabled={loadingNfe}></Button>
            </div>
        </>
    )
}